<div id="error-404" fxLayout="column" fxLayoutAlign="center center">
    <div class="content" fxLayout="column" fxLayoutAlign="center center">
        <div class="error-code">404</div>
        <div class="message mb-16">{{ "NOT_FOUND_TEXT" | translate }}</div>
        <a class="back-link" [routerLink]="'/'" id="am-1353">{{ "GO_BACK_DASHBOARD" | translate }}</a>
    </div>
</div>
